import { createFormHook } from "@tanstack/react-form";
import type { ZodType } from "zod";

import { FormAsyncSelect, FormInput, FormSelect, FormTextarea } from "./fields";
import { fieldContext, formContext } from "./formContext";

/**
 * Form hook for the whole app. Fields are rendered with `form.AppField` and read through `field.*`
 * (`field.Input`, `field.Textarea`, `field.Select`, `field.AsyncSelect`), never raw `form.Field`.
 * Validation: `validators: schemaValidators(schema)`.
 */
export const { useAppForm } = createFormHook({
  fieldComponents: {
    Input: FormInput,
    Textarea: FormTextarea,
    Select: FormSelect,
    AsyncSelect: FormAsyncSelect,
  },
  formComponents: {},
  fieldContext,
  formContext,
});

/**
 * The ONE validator source: the schema on `validators.onChange` and nothing else. Submit re-runs it
 * and touches every field, so a blank submit still blocks; adding `onSubmit` or `onBlur` doubles errors.
 */
export const schemaValidators = <TSchema extends ZodType>(schema: TSchema): { onChange: TSchema } => ({
  onChange: schema,
});
